import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { phoneNumberValidator, responsable } from 'src/app/directives/patient-validator.directive';
import { Civilite } from 'src/app/interfaces/civilite';
import { Client } from 'src/app/interfaces/client';
import { CiviliteService } from 'src/app/services/api/civilite.service';
import { SuperAdminService } from 'src/app/services/api/super-admin.service';
import { ErrorService } from 'src/app/services/error.service';

@Component({
    selector: 'app-ps-form',
    templateUrl: './ps-form.component.html',
    styleUrls: ['./ps-form.component.scss']
})

export class PsFormComponent implements OnInit, AfterViewInit, OnDestroy {

    public psForm: FormGroup | undefined;

    /** list of banks */
    @Input() clients: Client[] = [];

    public clientMultiCtrl: FormControl = new FormControl('', [Validators.required]);

    /** control for the MatSelect filter keyword multi-selection */
    public clientMultiFilterCtrl: FormControl = new FormControl();

    /** list of banks filtered by search keyword */
    public filteredClientsMulti: ReplaySubject<Client[]> = new ReplaySubject<Client[]>(1);

    //@ts-ignore
    @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;

    /** Subject that emits when the component has been destroyed. */
    protected _onDestroy = new Subject<void>();

    @ViewChild('formDirective') private formDirective!: NgForm;

    public errorMessage: string = '';
    public errorType: string = '';
    civiliteTab: Civilite[] = [];

    constructor(private superAdminService: SuperAdminService,
                private errorService: ErrorService,
                public route: Router,
                private civiliteService: CiviliteService,
                 private translate: TranslateService) { }


    ngOnInit() {

        this.getCivilite();

        this.psForm = new FormGroup({
            lname: new FormControl(''),
            fname: new FormControl(''),
            email: new FormControl('', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]),
            phoneNumber: new FormControl('', [phoneNumberValidator()]),
            clients: this.clientMultiCtrl,
            civilite: new FormControl(''),
            responsable: new FormControl('false', [Validators.required]),
            res_email: new FormControl('', [responsable(), Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]),
            res_identifiant: new FormControl('', [responsable()]),
            res_description: new FormControl('', [responsable()])
        });


        this.psForm.get('responsable')?.valueChanges.subscribe(value => {
          if (value === 'true') {
              this.psForm?.get('res_email')?.setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]);
              this.psForm?.get('res_identifiant')?.setValidators([Validators.required]);
              this.psForm?.get('res_description')?.setValidators([Validators.required]);
          } else {
              this.psForm?.get('res_email')?.clearValidators();
              this.psForm?.get('res_identifiant')?.clearValidators();
              this.psForm?.get('res_description')?.clearValidators();
          }
          this.psForm?.get('res_email')?.updateValueAndValidity();
          this.psForm?.get('res_identifiant')?.updateValueAndValidity();
          this.psForm?.get('res_description')?.updateValueAndValidity();
      });


        this.filteredClientsMulti.next(this.clients.slice());

        this.clientMultiFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterClientsMulti();
            });
    }

    ngAfterViewInit() {
        //this.setInitialValue();
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    private getCivilite() {
        this.civiliteService.getCivilite().subscribe((res) => {
            if (res.result == 'SUCCESS') {
                this.civiliteTab = res.content;
            } else {
                this.errorService.errorType = res.result;
                this.errorService.errorMessage = res.content;
                this.route.navigate(['/error']);
            }
        }, (resError) => {
            this.errorService.errorType = "ERROR";
            this.errorService.errorMessage = resError.error.detail;
            this.route.navigate(['/error']);
        });
    }

    protected setInitialValue() {
        this.filteredClientsMulti
            .pipe(take(1), takeUntil(this._onDestroy))
            .subscribe(() => {
                this.multiSelect.compareWith = (a: Client, b: Client) => a && b && a.id === b.id;
            });
    }

    protected filterClientsMulti() {
        if (!this.clients) {
            return;
        }
        // get the search keyword
        let search = this.clientMultiFilterCtrl.value;
        if (!search) {
            this.filteredClientsMulti.next(this.clients.slice());
            return;
        } else {
            search = search.toLowerCase();
        }

        // filter the banks
        this.filteredClientsMulti.next(
            this.clients.filter(client => client.name.toLowerCase().indexOf(search) > -1)
        );
    }

    addPS(psValue: any) {
        let values = psValue;
        this.superAdminService.addPs(values).subscribe((res) => {
            if (res.result == 'SUCCESS') {
              this.errorMessage = this.translate.instant(res.content);
                this.errorType = res.result;
                this.formDirective.resetForm();
            } else {
              const errors = this.translate.instant(res.content.split(';'));
              this.errorMessage = Object.values(errors).join('.');
                this.errorType = res.result;
            }
        });
    }

    public hasError = (controlName: string, errorName: string) => {
        return this.psForm?.controls[controlName].hasError(errorName);
    }

}
